import React from 'react';
export function BonusSection() {
  return <section id="bonos" className="py-12 md:py-16 text-center" style={{
    background: 'linear-gradient(160deg, var(--blush) 0%, var(--lilac) 100%)'
  }} data-id="element-16">
      <div className="max-w-[960px] mx-auto px-5" data-id="element-17">
        <p className="text-[10px] tracking-[4px] uppercase text-center mb-2.5" style={{
        color: 'var(--rose-deep)'
      }} data-id="element-18">
          Incluido sin costo adicional
        </p>

        <h2 className="font-serif font-normal max-w-[600px] mx-auto mb-2" style={{
        fontSize: 'clamp(26px, 4.5vw, 44px)',
        color: 'var(--ink)'
      }} data-id="element-19">
          Dos bonos terapéuticos
          <br data-id="element-20" />
          <em style={{
          color: 'var(--rose-deep)',
          fontStyle: 'italic'
        }} data-id="element-21">
            que potencian cada ritual
          </em>
        </h2>

        <p className="text-[14px] max-w-[500px] mx-auto mb-8" style={{
        color: 'var(--ink-soft)',
        lineHeight: 1.6
      }} data-id="element-22">
          Los recibís{' '}
          <strong style={{
          color: 'var(--ink)',
          fontWeight: 500
        }} data-id="element-23">
            gratis
          </strong>{' '}
          con tu compra hoy. Juntos tienen un valor real de
          <strong style={{
          color: 'var(--ink)',
          fontWeight: 500
        }} data-id="element-24">
            {' '}
            $21.980
          </strong>
          . Son tuyos.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-25">
          {/* Bonus 1 */}
          <div className="fade-in rounded-2xl overflow-hidden text-left transition-transform duration-300 hover:-translate-y-1.5" style={{
          background: 'var(--white)',
          boxShadow: '0 8px 40px rgba(180,122,138,.15)'
        }} data-id="element-26">
            <div className="p-6 flex items-center justify-center min-h-[160px]" style={{
            background: 'linear-gradient(135deg, var(--blush-mid), var(--lilac))'
          }} data-id="element-27">
              <img src="https://cdn.shopify.com/s/files/1/0752/3211/6894/files/BONO_1_04cb11de-8fc2-4f0e-a945-fc84bce08636.png?v=1772815275" alt="Bono 1: Diario Terapéutico de Liberación Emocional" className="max-h-[130px] w-auto" style={{
              filter: 'drop-shadow(0 8px 20px rgba(180,122,138,.3))'
            }} data-id="element-28" />
            </div>
            <div className="p-5 pb-6" data-id="element-29">
              <span className="inline-block text-[9px] font-medium tracking-[3px] uppercase py-[5px] px-3.5 rounded-full mb-3" style={{
              background: 'linear-gradient(135deg, var(--gold), var(--gold-light))',
              color: 'var(--ink)'
            }} data-id="element-30">
                Bono 1 · Gratis
              </span>
              <h3 className="font-serif font-medium mb-2 leading-tight" style={{
              fontSize: 'clamp(18px, 3vw, 24px)',
              color: 'var(--ink)'
            }} data-id="element-31">
                Diario Terapéutico de Liberación Emocional
              </h3>
              <p className="text-[13px] leading-relaxed mb-4" style={{
              color: 'var(--muted)'
            }} data-id="element-32">
                Ejercicios de escritura dirigida basados en la metodología de
                Pennebaker.{' '}
                <strong style={{
                color: 'var(--ink-soft)',
                fontWeight: 500
              }} data-id="element-33">
                  No es un diario en blanco
                </strong>{' '}
                — son preguntas específicas que desbloquean lo que la mente aún
                no pudo expresar. Ideal para usar antes, durante o después de
                cada ritual. Profundiza el proceso de cierre sin guía externa.
              </p>
              <div className="flex items-center gap-3 pt-3" style={{
              borderTop: '1px solid var(--blush-mid)'
            }} data-id="element-34">
                <span className="text-[13px] line-through opacity-65" style={{
                color: 'var(--muted)'
              }} data-id="element-35">
                  Valor: $11.990
                </span>
                <span className="font-serif text-lg font-medium italic" style={{
                color: 'var(--rose-deep)'
              }} data-id="element-36">
                  Tuyo gratis ✦
                </span>
              </div>
            </div>
          </div>

          {/* Bonus 2 */}
          <div className="fade-in rounded-2xl overflow-hidden text-left transition-transform duration-300 hover:-translate-y-1.5" style={{
          background: 'var(--white)',
          boxShadow: '0 8px 40px rgba(180,122,138,.15)'
        }} data-id="element-37">
            <div className="p-6 flex items-center justify-center min-h-[160px]" style={{
            background: 'linear-gradient(135deg, var(--blush-mid), var(--lilac))'
          }} data-id="element-38">
              <img src="https://cdn.shopify.com/s/files/1/0752/3211/6894/files/BONO_2_6bbd54e4-7ea7-4559-b798-8fb66bf71025.png?v=1772815275" alt="Bono 2: 7 Rituales de Emergencia Emocional" className="max-h-[130px] w-auto" style={{
              filter: 'drop-shadow(0 8px 20px rgba(180,122,138,.3))'
            }} data-id="element-39" />
            </div>
            <div className="p-5 pb-6" data-id="element-40">
              <span className="inline-block text-[9px] font-medium tracking-[3px] uppercase py-[5px] px-3.5 rounded-full mb-3" style={{
              background: 'linear-gradient(135deg, var(--gold), var(--gold-light))',
              color: 'var(--ink)'
            }} data-id="element-41">
                Bono 2 · Gratis
              </span>
              <h3 className="font-serif font-medium mb-2 leading-tight" style={{
              fontSize: 'clamp(18px, 3vw, 24px)',
              color: 'var(--ink)'
            }} data-id="element-42">
                7 Rituales de Emergencia Emocional
              </h3>
              <p className="text-[13px] leading-relaxed mb-4" style={{
              color: 'var(--muted)'
            }} data-id="element-43">
                Rituales cortos (
                <strong style={{
                color: 'var(--ink-soft)',
                fontWeight: 500
              }} data-id="element-44">
                  5–15 min
                </strong>
                ) para los momentos en que el pasado aparece sin aviso: una
                fecha que duele, una canción que te devuelve, una noche de
                rumia. Diseñados para la <em data-id="element-45">crisis aguda</em> — cuando no podés
                hacer un ritual completo pero necesitás algo que te ancle al
                presente. <u data-id="element-46">No existe en ningún otro producto del mercado</u>.
              </p>
              <div className="flex items-center gap-3 pt-3" style={{
              borderTop: '1px solid var(--blush-mid)'
            }} data-id="element-47">
                <span className="text-[13px] line-through opacity-65" style={{
                color: 'var(--muted)'
              }} data-id="element-48">
                  Valor: $9.990
                </span>
                <span className="font-serif text-lg font-medium italic" style={{
                color: 'var(--rose-deep)'
              }} data-id="element-49">
                  Tuyo gratis ✦
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}